import React, { useState } from 'react';

// Styles
import './App.css';
import './styles/global.css';
import './components/BackgroundVideo.css';
import './components/Navigation.css';
import './components/BackToTop.css';

// Components
import BackgroundVideo from './components/BackgroundVideo';
import Navigation from './components/Navigation';
import MenuIcon from './components/MenuIcon';
import AboutUs from './components/AboutUs';
import BackToTop from './components/BackToTop';
import RoomsGallery from './components/RoomsGallery';
import PrestigeSection from './components/PrestigeSection';

// Data
import { siteContent } from './data/siteContent';

// Component interfaces
interface HeaderProps {
  isMenuOpen: boolean;
  setIsMenuOpen: (isOpen: boolean) => void;
}

interface HomePageProps {
  content: typeof siteContent;
}

// Sub-components
const Header: React.FC<HeaderProps> = ({ isMenuOpen, setIsMenuOpen }) => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <header className="header">
      <div className="header-content">
        <a 
          href="#home" 
          className="logo-link"
          onClick={(e) => {
            e.preventDefault();
            scrollToTop();
          }}
        >
          <div className="logo">
            <img
              src="images/vstudio-logo-square.png" 
              alt="V Studio Logo" 
              className="logo-image"
            />
            <span className="logo-sub">STUDIO</span>
          </div>
        </a>
        <Navigation 
          items={siteContent.header.navigation}
          isOpen={isMenuOpen} 
          onClose={() => setIsMenuOpen(false)} 
        />
        <MenuIcon 
          isOpen={isMenuOpen} 
          onClick={() => setIsMenuOpen(!isMenuOpen)} 
        />
      </div>
    </header>
  );
};

const HomePage: React.FC<HomePageProps> = ({ content }) => (
  <>
    <main className="main-content">
      <section id="home">
        <BackgroundVideo 
          images={content.hero.backgroundImages} 
          title={content.hero.title.toString()} 
          callToAction={content.hero.callToAction.toString()} 
        />
      </section>
      <section id="rooms">
        <RoomsGallery content={content.rooms} />
      </section>
      <section id="prestige">
        <PrestigeSection content={content.prestige} />
      </section>
      <section id="about">
        <AboutUs content={content.aboutUs} />
      </section>
    </main>
    <BackToTop />
  </>
);

// Main App component
function App() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <div className="App">
      <Header isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} />
      <HomePage content={siteContent} />
    </div>
  );
}

export default App;
